import React, { memo } from "react"
import { AntDesign } from "@expo/vector-icons";
import { Pressable, View, Text, StyleSheet } from "react-native";
import RenderIf from "./RenderIf";

interface CandidateCardProps {
	photoUrl?: string;
	id: string;
	name: string;
	profession: string;
	location: string;
	recruitmentCompany: string;
	onDelete?: () => void;
	onPress?: () => void;
	onPressDoc: () => void;
}

const CandidateCard = ({ profession, name, location, onDelete, onPressDoc, onPress, recruitmentCompany }: CandidateCardProps) => {
	return (
		<Pressable style={styles.container} onPress={onPress}>
			<View style={styles.avatar}>
				<AntDesign name="user" size={30} color="#a5a5a5" />
			</View>

			<View style={styles.infoContainer}>
				<Text style={styles.name}>{name}</Text>
				<Text style={styles.profession}>{profession}</Text>
				<Text style={styles.location}>{location}</Text>
				<Text
					style={[
						styles.location,
						{
							backgroundColor: '#cdcdcd',
							alignSelf: 'flex-start',
							paddingVertical: 3,
							paddingHorizontal: 6,
							marginTop: 10,
							borderRadius: 5
						}
					]}
				>
					{recruitmentCompany}
				</Text>
			</View>

			<View
				style={{
					height: '100%',
					justifyContent: 'space-between'
				}}
			>
				<RenderIf condition={!!onDelete}>
					<Pressable onPress={onDelete}>
						<AntDesign name="closecircleo" size={20} color="black" />
					</Pressable>
				</RenderIf>

				<Pressable onPress={onPressDoc}>
					<AntDesign name="filetext1" size={20} color="black" />
				</Pressable>
			</View>
		</Pressable>
	)
}

const styles = StyleSheet.create({
	container: {
		width: 250,
		borderWidth: 1,
		borderColor: 'rgba(0, 0, 0, .1)',
		marginBottom: 20,
		marginRight: 20,
		padding: 10,
		borderRadius: 8,
		backgroundColor: '#fff',
		flexDirection: 'row',
		alignItems: 'center'
	},
	avatar: {
		width: 50,
		height: 50,
		borderRadius: 25,
		backgroundColor: '#e5e5e5',
		justifyContent: 'center',
		alignItems: 'center'
	},
	infoContainer: {
		marginLeft: 10,
		flex: 1
	},
	name: {
		fontWeight: 'bold',
		fontSize: 16
	},
	profession: {
		marginVertical: 5
	},
	location: {
		fontSize: 12
	}
})

export default memo(CandidateCard);